<template>
  <footer id="footer" class="main-color mt-5 text-light text-center p-3">
    <span>{{this.config.copyright}}</span>
  </footer>
</template>
<script>
export default {
  name: 'AdjustmentFooter',
  data () {
    return {}
  }
}
</script>



// WEBPACK FOOTER //
// src/components/AdjustmentFooter.vue